var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('td',{class:_vm.rootClasses,style:({left: _vm.stuckLeftPosition ? (_vm.stuckLeftPosition + "px") : null}),attrs:{"data-label":_vm.label}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }